import React from 'react';
import { Search, Sliders, Check, Archive, X, LogOut, ChevronsLeft, ChevronsRight } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';
import kaiaLogo from '../assets/image/kaia_logo.png';
import logoIcon from '../assets/image/logoicon.png';
import * as CONST from '../constants';
import styles from './Sidebar.module.css';

const Sidebar = ({ isSidebarOpen, setSidebarOpen, currentPage, setCurrentPage, selectedFarm, isCollapsed, setCollapsed }) => {
    // 기본 메뉴 아이템
    const { user, logout } = useAuth();
    const baseNavItems = [
        { name: '농장검색', id: CONST.PAGE_FARM_SEARCH, icon: Search, requiredFarm: false },
        { name: '씨수소선택', id: CONST.PAGE_SIRE_SELECTION, icon: Sliders, requiredFarm: true },
        { name: '계획교배 실행', id: CONST.PAGE_MATING_PLAN, icon: Check, requiredFarm: true },
        { name: '정액 즐겨찾기', id: CONST.PAGE_INVENTORY, icon: Archive, requiredFarm: true },
    ];

    // 사용자 유형(mtype1 === "2")에 따라 '농장검색' 메뉴를 필터링
    let navItems = user?.mtype1 === CONST.USER_TYPE_FARM_OWNER ? baseNavItems.filter(item => item.id !== CONST.PAGE_FARM_SEARCH) : baseNavItems;

    // selectedFarm.gubun이 '3'인 경우 '보유품 관리' 메뉴 숨김
    if (selectedFarm?.gubun === '3') {
        navItems = navItems.filter(item => item.id !== CONST.PAGE_INVENTORY);
    }

    const handleNavClick = (pageId, requiredFarm) => {
        setCurrentPage(pageId, requiredFarm);
        setSidebarOpen(false); // 모바일에서 메뉴 선택 시 닫기
    };

    return (
        <>
            {/* 모바일 오버레이 */}
            {isSidebarOpen && (
                <div
                    className={styles['sidebar-overlay']}
                    onClick={() => setSidebarOpen(false)}
                ></div>
            )}

            <div
                className={`${styles.sidebar} ${isSidebarOpen ? styles['is-open'] : ''} ${isCollapsed ? styles['is-collapsed'] : ''}`}
            >
                <div className={styles['sidebar-header']}>
                    <img
                        src={isCollapsed ? logoIcon : kaiaLogo}
                        alt="KAIA Logo"
                        className={isCollapsed ? styles['sidebar-logo-icon'] : styles['sidebar-logo-full']} />
                    <button onClick={() => setSidebarOpen(false)} className={styles['sidebar-close-button']}>
                        <X size={24} />
                    </button>
                </div>

                <div className={styles['sidebar-content']}>
                    <nav>
                        <ul style={{ listStyle: 'none', padding: 0, margin: 0, display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
                            {navItems.map(item => (
                                <li key={item.id}>
                                    <button
                                        onClick={() => handleNavClick(item.id, item.requiredFarm)}
                                        className={`${styles['nav-item']} ${currentPage === item.id ? styles.active : ''}`}
                                        title={isCollapsed ? item.name : ''}
                                    >
                                        <item.icon size={20} />
                                        <span className={styles['nav-item-text']}>{item.name}</span>
                                    </button>
                                </li>
                            ))}
                        </ul>
                    </nav>

                </div>

                <div className={styles['sidebar-footer']}>
                    {user?.mtype1 === CONST.USER_TYPE_FARM_OWNER ? (
                        <div className={styles['selected-farm-info']}>
                            <div style={{ fontSize: '0.75rem', color: '#9ca3af', marginBottom: '0.5rem' }}>농장주:</div>
                            <div style={{ backgroundColor: '#d1fae5', color: '#065f46', padding: '0.5rem', borderRadius: '0.375rem', fontSize: '0.875rem', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', fontWeight: '500' }}>
                                {selectedFarm.owner}
                            </div>
                        </div>
                    ) : (
                        <div className={styles['selected-farm-info']}>
                            <div style={{ fontSize: '0.75rem', color: '#9ca3af', marginBottom: '0.5rem' }}>선택 농장:</div>
                            {selectedFarm.id ? (
                                <div style={{ backgroundColor: '#eef2ff', color: '#4338ca', padding: '0.5rem', borderRadius: '0.375rem', fontSize: '0.875rem', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', fontWeight: '500' }}>
                                    {selectedFarm.name} ({selectedFarm.id})
                                </div>
                            ) : (
                                <div style={{ backgroundColor: '#fef2f2', padding: '0.5rem', borderRadius: '0.375rem', fontSize: '0.875rem', color: '#b91c1c' }}>
                                    농장을 선택해주세요.
                                </div>
                            )}
                        </div>
                    )}
                    <button onClick={logout} className={styles['logout-button']}>
                        <LogOut size={20} />
                        <span className={styles['nav-item-text']}>로그아웃</span>
                    </button>
                    <button onClick={() => setCollapsed(!isCollapsed)} className={styles['sidebar-toggle-button']}>
                        {isCollapsed ? <ChevronsRight size={20} /> : <ChevronsLeft size={20} />}
                        <span className={styles['nav-item-text']}>축소</span>
                    </button>
                </div>
            </div>
        </>
    );
};

export default Sidebar;
